// extracted by mini-css-extract-plugin
export var dropdownContainer = "_r7-0";
export var leftAlign = "_r7-4";
export var listItem = "_r7-2";
export var listItemWrapper = "_r7-1";
export var operationText = "_r7-3";